<template>
  <div class="authentication">
    <div class="ui top header">Authentication</div>
    <div class="content">
      <span v-if="error_message" class="error">{{ error_message }}</span>
      <table class="ui celled table">
        <tbody>
          <tr>
            <td class="four wide">Username</td>
            <td>
              <span v-if="errors.first('username')" class="error">{{
                errors.first('username')
              }}</span>
              <div
                :class="{ error: errors.first('username') }"
                class="ui fluid input"
              >
                <input
                  v-validate="'required|email'"
                  v-model="credentials.username"
                  type="email"
                  placeholder="Username"
                  name="username"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="four wide">Password</td>
            <td>
              <span v-if="errors.first('password')" class="error">{{
                errors.first('password')
              }}</span>
              <div
                :class="{ error: errors.first('password') }"
                class="ui fluid input"
              >
                <input
                  v-validate="'required'"
                  v-model="credentials.password"
                  type="password"
                  placeholder="Password"
                  name="password"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="center aligned">
              <button
                :disabled="loading"
                class="ui button green"
                @click="authenticate()"
              >
                Log In
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped>
.authentication {
  margin: 50px auto;
  width: 500px;
  height: 100%;
}

.table {
  width: 100%;
}

.error {
  color: #c00;
}
</style>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Authentication',
  data() {
    return {
      error_message: '',
      loading: false,
      credentials: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapGetters({})
  },
  mounted() {},
  methods: {
    authenticate() {
      this.error_message = ''
      this.loading = true
      axios
        .post('/login', this.credentials)
        .then((response) => {
          this.$store.dispatch('setAuth', response.data)
          this.loading = false
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.log(err)
          this.loading = false
          this.error_message = 'Authentication failed!'
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Authentication.vue?c2c3e81a